/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Browse_Plans_ButtonInputs */

const en_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse plans`)
};

const id_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telusuri paket`)
};

const ms_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semak imbas pelan`)
};

const ca_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veure plans`)
};

const cs_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procházet předplatná`)
};

const da_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennemse abonnementer`)
};

const de_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnements durchsuchen`)
};

const et_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sirvi plaane`)
};

const es_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar suscripciones`)
};

const fr_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les abonnements`)
};

const hr_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pregledajte pretplate`)
};

const it_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza piani`)
};

const lv_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skatīt plānus`)
};

const lt_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peržiūrėti planus`)
};

const hu_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Előfizetési csomagok megtekintése`)
};

const nl_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementen bekijken`)
};

const nb_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk i abonnementer`)
};

const pl_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeglądaj usługi`)
};

const pt_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar planos`)
};

const ro_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descoperă planurile`)
};

const sk_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozrieť plány`)
};

const sl_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prebrskaj pakete`)
};

const fi_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selaa tilauksia`)
};

const sv_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bläddra bland planer`)
};

const vi_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem các gói`)
};

const tr_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planlara göz atın`)
};

const el_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αναζήτηση προγραμμάτων`)
};

const bg_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прегледай плановете`)
};

const ru_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просмотр планов`)
};

const sr_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прегледајте пакете`)
};

const uk_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переглянути плани`)
};

const ka_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გეგმების დათვალიერება`)
};

const hi_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लान्स ब्राउज करें`)
};

const th_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียกดูแพ็กเกจต่างๆ`)
};

const ko_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랜 둘러보기`)
};

const zh_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览套餐`)
};

const zh_tw_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`瀏覽方案`)
};

const ja_browse_plans_button = /** @type {(inputs: Browse_Plans_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プランを見る`)
};

/**
* | output |
* | --- |
* | "Browse plans" |
*
* @param {Browse_Plans_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const browse_plans_button = /** @type {((inputs?: Browse_Plans_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Browse_Plans_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_browse_plans_button(inputs)
	if (locale === "ms") return ms_browse_plans_button(inputs)
	if (locale === "ca") return ca_browse_plans_button(inputs)
	if (locale === "cs") return cs_browse_plans_button(inputs)
	if (locale === "da") return da_browse_plans_button(inputs)
	if (locale === "de") return de_browse_plans_button(inputs)
	if (locale === "et") return et_browse_plans_button(inputs)
	if (locale === "es") return es_browse_plans_button(inputs)
	if (locale === "fr") return fr_browse_plans_button(inputs)
	if (locale === "hr") return hr_browse_plans_button(inputs)
	if (locale === "it") return it_browse_plans_button(inputs)
	if (locale === "lv") return lv_browse_plans_button(inputs)
	if (locale === "lt") return lt_browse_plans_button(inputs)
	if (locale === "hu") return hu_browse_plans_button(inputs)
	if (locale === "nl") return nl_browse_plans_button(inputs)
	if (locale === "nb") return nb_browse_plans_button(inputs)
	if (locale === "pl") return pl_browse_plans_button(inputs)
	if (locale === "pt") return pt_browse_plans_button(inputs)
	if (locale === "ro") return ro_browse_plans_button(inputs)
	if (locale === "sk") return sk_browse_plans_button(inputs)
	if (locale === "sl") return sl_browse_plans_button(inputs)
	if (locale === "fi") return fi_browse_plans_button(inputs)
	if (locale === "sv") return sv_browse_plans_button(inputs)
	if (locale === "vi") return vi_browse_plans_button(inputs)
	if (locale === "tr") return tr_browse_plans_button(inputs)
	if (locale === "el") return el_browse_plans_button(inputs)
	if (locale === "bg") return bg_browse_plans_button(inputs)
	if (locale === "ru") return ru_browse_plans_button(inputs)
	if (locale === "sr") return sr_browse_plans_button(inputs)
	if (locale === "uk") return uk_browse_plans_button(inputs)
	if (locale === "ka") return ka_browse_plans_button(inputs)
	if (locale === "hi") return hi_browse_plans_button(inputs)
	if (locale === "th") return th_browse_plans_button(inputs)
	if (locale === "ko") return ko_browse_plans_button(inputs)
	if (locale === "zh") return zh_browse_plans_button(inputs)
	if (locale === "zh-tw") return zh_tw_browse_plans_button(inputs)
	if (locale === "ja") return ja_browse_plans_button(inputs)
	return en_browse_plans_button(inputs)
});